export const enum PlatformName {
    MAC = 'mac',
    WINDOWS = 'windows',
    LINUX = 'linux',
}

export type Source = {
    id: string;
    name: string;
    appIcon?: string;
    thumbnail: string;
};

export type ElectronVideoConstraints =
    | boolean
    | {
          mandatory: {
              chromeMediaSource: string;
              chromeMediaSourceId: string;
              minWidth: number;
              maxWidth: number;
              minHeight: number;
              maxHeight: number;
          };
          cursor: string;
      };

export class StreamManager {
    public selectedSource: Source | null = null;

    private videoConstraints: ElectronVideoConstraints;

    public constructor(
        private streamOptions: DisplayMediaStreamOptions | undefined,
        private originGetDisplayMedia: (options?: DisplayMediaStreamOptions | undefined) => Promise<MediaStream>,
    ) {
        const video = streamOptions?.video || false;

        const maxWidth =
            typeof video !== 'boolean' &&
            (typeof video?.width === 'object'
                ? video.width.ideal || video.width.exact || video.width.max
                : video.width);

        const maxHeight =
            typeof video !== 'boolean' &&
            (typeof video?.height === 'object'
                ? video.height.ideal || video.height.exact || video.height.max
                : video.height);

        this.videoConstraints =
            typeof video === 'boolean'
                ? video
                : {
                      mandatory: {
                          chromeMediaSource: 'desktop',
                          chromeMediaSourceId: '',
                          minWidth: 640,
                          maxWidth: maxWidth || window.screen.width,
                          minHeight: 310,
                          maxHeight: maxHeight || window.screen.height,
                      },
                      cursor: 'motion',
                  };
    }

    public async getStream(): Promise<MediaStream> {
        if (!this.selectedSource) {
            throw new Error('Source is not selected');
        }

        await window.electronApi.ipcRenderer.setScreenShareSource(this.selectedSource!);
        return this.originGetDisplayMedia({
            video: this.streamOptions?.video,
            audio: false,
        });
    }
}
